

























































import Vue, { PropType } from 'vue';

export interface FormDataInterface {
  title?: string;
  url?: string;
}

export default Vue.extend({
  props: {
    sectionItem: {
      // FIXME update generated format
      // type: Object as () => CvSectionLinkItem,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { title, url } = this.sectionItem;
    return {
      formData: {
        title,
        url,
      } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
